const ur = {
  // App brand
  brand: 'حِساب فلو',
  brandTagline: 'کاروباری آپریٹنگ سسٹم',

  // Common
  cancel: 'منسوخ کریں',
  save: 'محفوظ کریں',
  saveChanges: 'تبدیلیاں محفوظ کریں',
  delete: 'حذف کریں',
  edit: 'ترمیم',
  close: 'بند کریں',
  back: 'واپس',
  search: 'تلاش',
  loading: 'لوڈ ہو رہا ہے...',
  actions: 'اقدامات',
  status: 'حالت',
  paymentMethod: 'ادائیگی کا طریقہ',
  cash: 'نقد',
  online: 'آن لائن',
  attachment: 'منسلکہ',
  view: 'دیکھیں',
  date: 'تاریخ',
  time: 'وقت',
  name: 'نام',
  phone: 'فون',
  cnic: 'شناختی کارڈ',
  area: 'علاقہ',
  areaPH: 'علاقہ / خطہ درج کریں',
  areaFilter: 'علاقے کے مطابق فلٹر کریں',
  allAreas: 'تمام علاقے',
  areaWiseSummary: 'علاقے کے مطابق خلاصہ',
  selectArea: '-- علاقہ منتخب کریں --',
  addNewArea: 'نیا علاقہ شامل کریں',
  outstanding: 'بقایا',
  amount: 'رقم',
  description: 'تفصیل',
  category: 'زمرہ',
  type: 'قسم',
  total: 'کل',
  none: 'نامعلوم',
  yes: 'ہاں',
  no: 'نہیں',
  allTime: 'تمام وقت',
  refresh: 'ریفریش',
  printReport: 'رپورٹ پرنٹ کریں',
  printSavePDF: 'پرنٹ / PDF محفوظ کریں',
  printBarcode: 'بار کوڈ پرنٹ کریں',
  generateBarcode: 'بار کوڈ بنائیں',
  labelQuantity: 'لیبل کی تعداد',
  print: 'پرنٹ کریں',
  closeBtn: '← بند کریں',
  generatedBy: 'حِساب فلو کے ذریعے تیار کردہ',
  generatingPdf: 'پی ڈی ایف بن رہی ہے...',
  pdfDownloadedShareWA: 'رپورٹ پی ڈی ایف ڈاؤن لوڈ ہو گئی ہے! کھلی ہوئی واٹس ایپ چیٹ میں منسلک کریں۔',

  // Auth / Login
  shopLogin: 'دکان لاگ ان',
  registerBusiness: 'کاروبار رجسٹر کریں',
  signInToShop: 'اپنی دکان میں لاگ ان کریں',
  registeredPhone: 'رجسٹرڈ فون نمبر',
  fourDigitPIN: '4 ہندسوں کا تنظیم پن',
  loginBtn: 'میری لیجر تک رسائی >',
  loginHint: 'اپنا رجسٹرڈ فون اور مختص پن استعمال کریں',
  loginNoAccess: 'رسائی نہیں ہے؟ اپنا کاروبار رجسٹر کریں یا اپنے ایڈمن سے رابطہ کریں۔',
  rememberMe: 'مجھے یاد رکھیں',

  // Email OTP sign-in
  signInWithEmail: 'ای میل سے سائن ان کریں',
  emailSignIn: 'ای میل سے سائن ان',
  emailSignInHint: 'ہم آپ کو 6 ہندسوں کا لاگ ان کوڈ ای میل کریں گے',
  emailAddress: 'ای میل پتہ',
  sendCode: 'کوڈ بھیجیں',
  sendingCode: 'بھیج رہے ہیں...',
  sixDigitCode: '6 ہندسوں کا لاگ ان کوڈ',
  verifyAndSignIn: 'تصدیق کریں اور سائن ان کریں',
  resendCode: 'کوڈ دوبارہ بھیجیں',
  resendIn: '{s} سیکنڈ میں دوبارہ بھیجیں',
  otpSent: 'اگر یہ پتہ رجسٹرڈ ہے تو لاگ ان کوڈ بھیج دیا گیا ہے۔',
  otpSentToLabel: 'ہم نے {email} پر 6 ہندسوں کا کوڈ بھیجا ہے',
  otpCodeIncomplete: 'براہ کرم 6ویں اعداد مکمل کریں۔',
  changeEmail: 'ای میل تبدیل کریں',
  usePhoneAndPin: 'فون اور پن استعمال کریں',
  emailSignInUnavailable: 'اس سرور پر ای میل سائن ان ابھی فعال نہیں ہے۔ براہ کرم فون اور پن استعمال کریں۔',
  registerTitle: 'اپنا کاروبار رجسٹر کریں',
  registerSubtitle: 'ایڈمن کی منظوری کے لیے اپنی تفصیلات جمع کریں',
  shopName: 'کاروبار/دکان کا نام',
  ownerName: 'مالک کا پورا نام',
  contactEmail: 'رابطہ ای میل',
  mobilePhone: '.mobائل فون نمبر',
  shopAddress: 'دکان کا پتہ (اختیاری)',
  subscriptionPlan: 'سبسکرپشن پلان',
  plan2Days: '2 دن ٹرائل',
  plan1Month: '1 ماہ',
  plan1Year: '1 سال',
  plan3Years: '3 سال',
  planLifetime: 'عمر بھر',
  submitRegistration: 'رجسٹریشن جمع کریں >',
  regPendingTitle: 'رجسٹریشن جمع ہو گئی!',
  regPendingMsg: 'آپ کی سبسکرپشن درخواست ایڈمن کے جائزے کا انتظار کر رہی ہے۔ منظوری کے بعد ایڈمن آپ کو 4 ہندسوں کا پن فراہم کرے گا۔',
  goToLogin: 'لاگ ان پر جائیں',

  // Admin Portal
  adminPortal: 'ایڈمن پورٹل',
  adminSubtitle: 'رجسٹریشن، منظوری اور ڈیٹابیس کا انتظام کریں',
  adminBusinessTitle: 'کاروبار رجسٹریشن اور ڈیٹابیس میمنت',
  adminUsername: 'ایڈمن صارف نام',
  adminPassword: 'ایڈمن پاسورڈ',
  accessAdmin: 'ایڈمن ڈیش بورڈ تک رسائی >',
  pendingRequests: 'زیر التوا درخواستیں',
  renewalRequests: 'تجدید درخواستیں',
  allOrganizations: 'تمام تنظیمیں',
  backups: 'بیک اپ',
  totalRegistered: 'کل رجسٹرڈ',
  pendingApproval: 'منظوری زیر التوا',
  activeShops: 'فعال دکانیں',
  deactivated: 'غیر فعال',
  backupsLogged: 'بیک اپ لاگ',
  dbSize: 'ڈیٹابیس سائز (کل)',
  noPendingReqs: 'کوئی زیر التوا رجسٹریشن درخواست نہیں',
  noRenewalReqs: 'کوئی تجدید درخواست نہیں',
  searchOrgs: 'نام، فون یا مالک سے تلاش کریں...',
  noOrgs: 'ابھی تک کوئی تنظیم رجسٹر نہیں ہوئی۔',
  owner: 'مالک',
  phone: 'فون',
  email: 'ای میل',
  submitted: 'جمع کرایا',
  approve: 'منظور کریں',
  reject: 'مسترد کریں',
  deactivate: 'غیر فعال',
  activate: 'فعال',
  reApprove: 'دوبارہ منظوری',
  approveRenewal: 'تجدید منظور کریں',
  pinRequired: 'تنظیم پن (4 ہندسے)',
  approveCreateDB: 'منظور کریں اور ڈیٹابیس بنائیں',
  currentPlan: 'موجودہ پلان',
  ended: 'ختم ہوا',
  requested: 'درخواست کردہ',
  notSet: 'طے نہیں',
  selectOrgHint: 'تمام تنظیموں سے کوئی منتخب کریں...',
  runBackup: 'دستی بیک اپ چلائیں',
  download: 'ڈاؤن لوڈ',
  logOutAdmin: 'ایڈمن لاگ آؤٹ',
  backupType: '{type} بیک اپ',
  renewBtn: 'تجدید منظور کریں',
  rejectBtn: 'مسترد کریں',
  pendingBadge: 'زیر التوا',
  renewalBadge: 'تجدید',
  approvedBadge: 'منظور شدہ',
  deactivatedBadge: 'غیر فعال',

  // Lock Screen
  securityLock: 'سیکیورٹی لاک',
  lockHint: 'کاروباری لیجر تک رسائی کے لیے پن کوڈ درج کریں۔',
  loggedInAs: 'لاگ ان ہے',
  unlockBtn: 'لیجر انلاک کریں',
  verifying: 'تصدیق ہو رہی ہے...',

  // Subscription Expired
  subExpired: 'سبسکرپشن ختم',
  subExpiredMsg: 'آپ کی سبسکرپشن {name} کی ختم ہو گئی۔',
  subExpiredHint: 'ایپ استعمال جاری رکھنے کے لیے ایڈمن سے تجدید کی درخواست کریں۔',
  subExpiredPending: 'تجدید کی درخواست پہلے ہی بھیج دی گئی ہے۔ براہ کرم ایڈمن کی منظوری کا انتظار کریں۔',
  requestRenewal: 'تجدید کی درخواست',
  backToLogin: 'لاگ ان پر واپس',

  // Header / Nav
  dashboard: 'ڈیش بورڈ',
  customers: 'صارفین',
  suppliers: 'سپلائرز',
  cashBook: 'کیش بک',
  bank: 'بینک',
  bankAccounts: 'بینک اکاؤنٹس',
  bankAccount: 'بینک اکاؤنٹ',
  bankName: 'بینک کا نام',
  selectBankName: '-- بینک منتخب کریں --',
  addBankDetails: 'بینک کی تفصیلات شامل کریں',
  hideBankDetails: 'چھپائیں',
  bankTransactions: 'بینک لین دین',
  accountTitle: 'اکاؤنٹ عنوان',
  accountNumber: 'اکاؤنٹ نمبر',
  iban: 'آئی بی اے این',
  paymentReference: 'ادائیگی کا حوالہ',
  branch: 'برانچ',
  openingBalance: 'افتتاحی بیلنس',
  currentBalance: 'موجودہ بیلنس',
  activeAccount: 'فعال اکاؤنٹ',
  addBankAccount: 'بینک اکاؤنٹ شامل کریں',
  editBankAccount: 'بینک اکاؤنٹ میں ترمیم',
  bankTransactionType: 'لین دین کی قسم',
  transfer: 'منتقلی',
  adjustment: 'ایڈجسٹمنٹ',
  deposit: 'جمع',
  withdrawal: 'اخراج',
  chooseBankAccount: 'بینک اکاؤنٹ منتخب کریں',
  selectBankAccount: '-- بینک اکاؤنٹ منتخب کریں --',
  bankAccountAdded: 'بینک اکاؤنٹ شامل ہو گیا۔',
  bankAccountUpdated: 'بینک اکاؤنٹ میں ترمیم ہو گئی۔',
  bankAccountDeleted: 'بینک اکاؤنٹ حذف ہو گیا۔',
  incomeExpense: 'آمدنی اور اخراجات',
  products: 'مصنوعات',
  stockInventory: 'اسٹاک / انوینٹری',
  staffSalaries: 'عملہ اور تنخواہیں',
  billBook: 'بل بک',
  viewLedger: 'لیجر دیکھیں',
  settings: 'ترتیبات',
  designs: 'ڈیزائنز',
  gallery: 'گیلری',
  switchOrg: 'تنظیم تبدیل کریں',
  logOut: 'لاگ آؤٹ',

  // Dashboard
  dashTitle: 'ڈیش بورڈ کا جائزہ',
  customerReceivables: 'صارفین سے وصولی',
  youGet: 'آپ کو ملتا ہے',
  fromCustomerTabs: 'صارف لیجر ٹیبوں سے',
  supplierPayables: 'سپلائرز کو ادائیگی',
  youGive: 'آپ دیتے ہیں',
  fromSupplierTabs: 'سپلائر لیجر سٹیٹمنٹس سے',
  cashBalance: 'دستیاب کیش بیلنس',
  inSafe: 'خزانے میں',
  cashFlow: 'کیش آمد - نکاسی',
  walkInSales: 'واک-اِن فروخت',
  walkInSalesChip: 'نقد فروخت',
  walkInSalesDesc: 'بغیر صارف کے انویسز',
  lowStock: 'کم اسٹاک انتباہ',
  lowStockMsg: '{count} اشیاء انوینٹری میں کم حفظتی حد سے نیچے ہیں۔',
  quickOps: 'فوری کاروباری کارروائیاں',
  newCustomerSupplier: 'نیا صارف / سپلائر',
  createInvoice: 'انویس بنائیں',
  addExpenseIncome: 'اخراجات/آمدنی شامل کریں',
  viewStock: 'اسٹاک دیکھیں',
  viewBillBook: 'بل بک دیکھیں',
  incomeVsExpense: 'آمدنی بمقابلہ اخراجات',
  net: 'خالص',
  financialPosition: 'مالی حالت',

  // Dashboard Quick Actions
  staffDirectoryTitle: 'عملہ ڈائری',
  productCatalog: 'مصنوعات کی فہرست',
  invoiceBuilder: 'انویس بلڈر',
  performanceReports: 'کارکردگی رپورٹس',

  // Customers
  searchCustomers: 'صارفین کا نام یا فون تلاش کریں...',
  noCustomers: 'کوئی صارف رجسٹر نہیں۔',
  addCustomer: 'صارف شامل کریں',
  balanceDue: 'باقی رقم',
  paying: 'ادائیگی',

  // Manage Users Tab
  loadingUsers: 'صارفین لوڈ ہو رہے ہیں...',
  addUser: 'صارف شامل کریں',
  inactive: 'غیر فعال',
  you: 'آپ',
  roleLabel: 'عہدہ:',
  pinLabel: 'پن کوڈ:',
  notSet: 'درج نہیں',
  deactivate: 'غیر فعال کریں',
  activate: 'فعال کریں',
  editUser: 'ترمیم کریں',
  newPinHint: 'نیا پن (پرانا رکھنے کے لیے خالی چھوڑیں)',
  pinHint: 'پن کوڈ (4 ہندسے)',
  adminRole: 'ایڈمن (مکمل رسائی)',
  managerRole: 'مینیجر',
  cashierRole: 'کیشیئر (کیش + کھاتہ)',
  viewerRole: 'ویور (صرف پڑھنے کی رسائی)',
  saveChanges: 'تبدیلیاں محفوظ کریں',
  nameLabel: 'نام',
  deactivateConfirm: 'کیا آپ اس صارف کو غیر فعال کرنا چاہتے ہیں؟',
  activateConfirm: 'کیا آپ اس صارف کو فعال کرنا چاہتے ہیں؟',
  addUsers: "صارفین شامل کریں",
  manageUsers: "صارفین کا انتظام",
  activityLog: "سرگرمی لاگ",
  switchUser: "صارف تبدیل کریں",

  // Suppliers
  searchSuppliers: 'سپلائر کا نام یا فون تلاش کریں...',
  noSuppliers: 'کوئی سپلائر رجسٹر نہیں۔',
  addSupplier: 'سپلائر شامل کریں',
  itemsSupplied: 'فراہم کردہ اشیاء',

  // Customer/Supplier Ledger
  backToList: 'فہرست پر واپس',
  whatsappReminder: 'واٹس ایپ یاد دہانی',
  printStatement: 'سٹیٹمنٹ پرنٹ کریں',
  receivableGet: 'وصولی (ملے گا)',
  payableGive: 'ادائیگی (دینا ہے)',
  clear: ' cleared',
  logNewEntry: 'نیا اندراج کریں',
  ledGave: 'دیا (-)',
  ledGot: 'لیا (+)',
  debit: 'ڈیبٹ',
  credit: 'کریڈٹ',
  genericEntry: 'عمومی اندراج',
  noTransactions: 'اس پارٹی کے لیے کوئی لین دین رجسٹر نہیں۔',
  entryNumber: '#',
  youGaveNeg: 'آپ نے دیا (−)',
  youGotPos: 'آپ نے لیا (+)',
  youPaidNeg: 'آپ نے ادائیگی کی (−)',
  theySuppliedPos: 'انہوں نے فراہم کیا (+)',
  gavePayNeg: 'دیا / ادائیگی (−)',
  gotSuppliedPos: 'لیا / فراہم کیا (+)',

  // Cash Book
  logCashEntry: 'کیش اندراج کریں',
  cashStatements: 'کیش سٹیٹمنٹس',
  searchByDetails: 'تفصیلات سے تلاش کریں...',
  cashIn: 'کیش آمد',
  cashOut: 'کیش نکاسی',
  noCashEntries: 'کوئی کیش فلو سٹیٹمنٹ رجسٹر نہیں۔',
  cashInBtn: 'کیش آمد (+)',
  cashOutBtn: 'کیش نکاسی (-)',
  cashFlowLabel: 'کیش فلو',

  // Income & Expense
  addExpenseIncomeTitle: 'اخراجات/آمدنی شامل کریں',
  ieSearch: 'زمرہ یا تفصیل سے تلاش کریں...',
  noLogs: 'کوئی لاگ نہیں ملا۔',
  expenses: 'اخراجات',
  categoryReport: 'زمرہ رپورٹ',
  transactions: 'لین دین',
  income: 'آمدنی',
  expense: 'خرچہ',
  salesIncome: 'فروخت کی آمدنی',
  staffSalary: 'عملے کی تنخواہ',
  shopUtilities: 'دکان کی سہولیات',
  generalExpenses: 'عمومی اخراجات',
  customCategory: '+ حسب ضرورت زمرہ...',
  netProfitLoss: 'خالص منافع / نقصان',

  // Products / Stock
  searchInventory: 'انوینٹری اشیاء تلاش کریں...',
  noProducts: 'کیٹلاگ میں کوئی مصنوعات نہیں۔',
  addProduct: 'مصنوعات شامل کریں',
  productName: 'مصنوعات کا نام',
  skuBarcode: 'SKU / بار کوڈ',
  unit: 'اکائی مقدار',
  purchasePrice: 'خریداری قیمت (Rs.)',
  salePrice: 'ریٹیل قیمت (Rs.)',
  openingStock: 'اسٹاک',
  lowStockAlert: 'کم اسٹاک انتباہ تعداد',
  optional: 'اختیاری',
  expirationDate: 'میعاد ختم ہونے کی تاریخ',
  expiryDateOptional: 'میعاد ختم ہونے کی تاریخ (اختیاری)',
  nameOrSku: 'نام / SKU',
  costPrice: 'خریداری قیمت',
  sellPrice: 'فروخت قیمت',
  stockStatus: 'اسٹاک کی حالت',
  totalValue: 'اسٹاک قیمت (لاگت)',
  inStock: 'اسٹاک میں',
  lowStock: 'کم اسٹاک',
  outOfStock: 'اسٹاک ختم',
  restock: 'اسٹاک بڑھائیں',
  currentStock: 'موجودہ اسٹاک',
  addQuantity: 'مقدار شامل کریں',
  productRestocked: '{name} میں {qty} کا اضافہ ہوا!',

  // Staff & Salaries
  staffTitle: 'عملہ اور تنخواہ مینجمنٹ',
  staffSubtitle: 'حاضری لاگ کریں، بنیادی تنخواہیں مینج کریں اور ادائیگیاں ٹریک کریں۔',
  staffSearch: 'عملہ یا تنخواہ تلاش کریں...',
  addEmployee: 'ملازم شامل کریں',
  paySalaries: 'تنخواہیں ادائیگی کریں',
  logAttendance: 'روزانہ حاضری لاگ کریں',
  attendanceDateHint: 'تاریخ منتخب کریں اور ہر ملازم کی حالت نشان لگائیں۔',
  present: 'حاضر',
  absent: 'غیر حاضر',
  leave: 'چھٹی',
  staffDirectory: 'عملہ ڈائری',
  employeesOf: '{filtered} میں سے {total} ملازمین',
  filterByName: 'نام، فون، شناختی کارڈ سے فلٹر کریں...',
  salaryType: 'تنخواہ کی قسم',
  baseSalary: 'بنیادی تنخواہ',
  salaryPayroll: 'تنخواہ پے رول کی تاریخ',
  searchByEmployee: 'ملازم کے نام سے تلاش کریں...',
  period: 'مدت',
  basic: 'بنیادی',
  allowances: 'الوانسز',
  deductions: 'کٹوتیاں',
  netPaid: 'خالص ادائیگی',
  salarySlip: 'تنخواہ سلپ',
  employee: 'ملازم',
  monthly: 'ماہانہ',
  daily: 'روزانہ',
  hourly: 'گھنٹہ وار',
  paid: 'ادا شدہ',
  unpaid: 'غیر ادا',
  noStaffFound: '"{query}" سے کوئی عملہ نہیں ملا۔',
  noStaffYet: 'ابھی تک کوئی عملہ شامل نہیں۔ "ملازم شامل کریں" پر کلک کریں۔',
  noPayrollYet: 'ابھی تک کوئی تنخواہ رجسٹر نہیں۔ "تنخواہیں ادائیگی کریں" پر کلک کریں۔',
  noPayrollMatch: '"{query}" سے کوئی پے رول ریکارڈ نہیں ملا۔',
  whatsapp: 'واٹس ایپ',

  // Bill Book
  purchaseInvoice: 'خریداری انویس',
  piLabel: 'PI',
  supplierDetails: 'سپلائر کی تفصیلات',
  backToSuppliers: 'سپلائرز پر واپس جائیں',
  purchaseInvoiceCreatedMsg: 'خریداری انویس بن گیا! پرنٹ کے لیے تیار ہے۔',
  invoiceBuilderTitle: 'انویس بلڈر',
  selectCustomer: 'صارف منتخب کریں',
  chooseCustomer: '-- صارف منتخب کریں --',
  invoiceNumber: 'انویس نمبر',
  dateOfIssue: 'تاریخ جاری',
  lineItems: 'لائن اشیاء',
  chooseProduct: '-- مصنوعات منتخب کریں --',
  orTypeItem: 'یا دستی نام لکھیں...',
  searchCustomerPH: 'نام یا فون نمبر سے تلاش کریں...',
  searchProductPH: 'نام یا SKU سے مصنوعات تلاش کریں...',
  noResults: 'کوئی نتائج نہیں ملے',
  pickFromContacts: 'رابطوں سے درآمد کریں (.vcf)',
  contactsAPINotSupported: 'اس براؤزر میں ڈیوائس کے رابطے دستیاب نہیں۔ Android پر Chrome آزمائیں۔',
  contactImportFailed: 'رابطے درآمد کرنے میں ناکامی',
  noContactsFound: 'فائل میں کوئی رابطے نہیں ملے',
  selectContact: 'رابطہ منتخب کریں',
  contactsFound: 'رابطے ملے',
  unknown: 'نامعلوم',
  qty: 'تعداد',
  rate: 'شرح',
  addItemRow: 'لائن شامل کریں',
  finalizePrint: 'انویس طے کریں اور پرنٹ کریں',
  placeOrder: 'آرڈر دیں',
  saveAndPrint: 'محفوظ کریں اور پرنٹ کریں',
  itemDescription: 'شے / تفصیل',
  unitPrice: 'فی اکائی قیمت',
  subtotal: 'ذیلی کل',
  noInvoices: 'ابھی تک کوئی انویس نہیں بنا۔',
  searchByNameOrPhone: 'نام یا فون نمبر سے تلاش کریں...',
  invoiceHistory: 'انویس کی تاریخ',
  createInvoice: 'انویس بنائیں',
  invoiceDeleted: 'انویس کامیابی سے حذف ہو گئی۔',
  invoiceUpdated: 'انویس کامیابی سے اپ ڈیٹ ہو گئی۔',
  deleteInvoice: 'انویس {{number}} حذف کریں؟',
  editInvoice: 'انویس میں ترمیم',
  createFirst: 'شروع کرنے کے لیے پہلی انویس بنائیں۔',

  // Invoice Print
  invoiceReceipt: 'انویس رسید',
  cashCustomer: 'کیش صارف',
  valuedCustomer: 'قدری صارف',
  invoice: 'انویس',
  invoiceSummary: 'انویس کا خلاصہ',
  totalRevenue: 'کل آمدنی',

  // Settings
  settingsTitle: 'ترتیبات',
  subPlan: 'سبسکرپشن پلان',
  currentPlanLabel: 'موجودہ پلان:',
  subActive: 'سبسکرپشن فعال ہے۔',
  expiresOn: '{date} کو ختم ہوگا ({days} دن باقی)',
  expiredOn: '{date} کو ختم ہو گیا',
  subExpiringSoon: 'آپ کا پلان جلد ختم ہو رہا ہے۔ رکاوٹ سے بچنے کے لیے تجدید کریں۔',
  subExpiredRestrict: 'آپ کی رسائی محدود ہو سکتی ہے۔ براہ کرم اپنا پلان تجدید کریں۔',
  subActiveFull: 'آپ کی سبسکرپشن فعال ہے۔',
  requestPlanRenewal: 'پلان تجدید کی درخواست',
  renewalRequested: 'تجدید درخواست جمع — ایڈمن کا انتظار',
  changePin: 'پن کوڈ تبدیل کریں',
  changePinDesc: 'آپ کا موجودہ پن لیجر انلاک کرنے کے لیے استعمال ہوتا ہے۔ تبدیل کرنے سے ایڈمن پورٹل میں دکھایا جانے والا پن اپڈیٹ ہوگا۔',
  currentPIN: 'موجودہ پن',
  newPIN: 'نیا پن',
  confirmNewPIN: 'نیا پن کی تصدیق',
  changePinBtn: 'پن تبدیل کریں',

  // Renewal Plan Modal
  selectRenewalPlan: 'تجدید پلان منتخب کریں',
  selectRenewalDesc: 'ایڈمن سے تجدید کی درخواست کے لیے سبسکرپشن پلان منتخب کریں۔',
  bestForTrying: 'آزمائش کے لیے بہترین',
  mostPopular: 'سب سے مقبول — زیادہ بچائیں',
  bestValue: 'بہترین قیمت — طویل مدت',
  trialDesc: '2 دن کی فوری آزمائش',
  sendRequest: 'درخواست بھیجیں',

  // Modals
  addNewProduct: 'نئی مصنوعات شامل کریں',
  addToCatalog: 'کیٹلاگ میں شامل کریں',
  productPhoto: 'مصنوعات کی تصویر',
  browsePhoto: 'تصویر تلاش کریں',
  replacePhoto: 'تصویر تبدیل کریں',
  gallery: 'گیلری',
  productGallery: 'مصنوعات کی گیلری',
  selectFromGallery: 'گیلری سے منتخب کریں',
  noPhotosYet: 'ابھی تک کوئی تصویر نہیں۔ مصنوعات بناتے یا ترمیم کرتے وقت تصویر شامل کریں۔',
  allCategories: 'تمام زمرے',
  productType: 'مصنوعات کی قسم',
  productTypePH: 'جیسے بیکری، الیکٹرانکس، گروسری',
  selectProductType: '-- قسم منتخب کریں --',
  addNewProductType: 'نئی قسم شامل کریں',
  allTypes: 'تمام اقسام',
  logEntry: 'اندراج: {name}',
  logCashEntryTitle: 'کیش اندراج کریں',
  logSalaryTitle: 'تنخواہ ادائیگی لاگ کریں',
  editParty: 'پارٹی میں ترمیم',
  editTransaction: 'لین دین میں ترمیم',
  editCashEntry: 'کیش اندراج میں ترمیم',
  editOperation: 'کارروائی میں ترمیم',
  editProduct: 'مصنوعات میں ترمیم',
  editStaff: 'عملے میں ترمیم',
  editCompany: 'کمپنی پروفائل میں ترمیم',
  confirmDelete: 'حذف کی تصدیق',
  transactionType: 'لین دین کی قسم',
  address: 'پتہ',
  cnicOptional: 'شناختی کارڈ (اختیاری)',
  saveParty: 'پارٹی محفوظ کریں',
  logOperationsFlow: 'کارروائی فلو لاگ کریں',
  logRecordBtn: 'ریکارڈ لاگ کریں',
  shopRent: 'دکان کا کرایہ',
  electricityBill: 'بجلی کا بل',
  packagingMaterial: 'پیکنگ مواد',
  rawIngredients: 'خام اشیاء',
  staffSalaryOption: 'عملے کی تنخواہ',
  salesReturn: 'فروخت واپسی',
  customCatOption: '+ حسب ضرورت زمرہ...',
  cashFlow: 'کیش فلو',
  detailsLabel: 'تفصیلات',
  chooseEmployeeTitle: 'ملازم منتخب کریں',
  unpaidAccrued: 'غیر ادا / جمع شدہ',
  paidOutDirectly: 'براہ راست ادا شدہ',
  addItemToInventory: 'انوینٹری میں شے شامل کریں',
  updateEmployeeInfo: 'ملازم کی معلومات اپڈیٹ کریں',
  unitType: 'اکائی کی قسم',
  stockQty: 'اسٹاک مقدار',
  unitsQty: 'یونٹس مقدار (هر پیک میں پیسز)',
  unitsQtyHelper: 'ایک پیک/ڈبے میں کتنی پیسز ہوتی ہیں (مثلاً 12)۔ اگر پروڈکٹ اکیلی پیس ہے تو 1 لکھیں۔',
  packCost: 'پیک کی لاگت',
  packRetail: 'پیک کی Retail قیمت',
  piecesPerPackLabel: 'هر پیک میں پیسز',
  onePackEquals: '1 پیک = {n} پیسز',
  stockShort: 'اسٹاک',
  insufficientStock: 'ان اشیاء کے لیے اسٹاک کافی نہیں:',
  needsQty: '{n} پیسز درکار ہیں',
  onlyQty: 'صرف {n} پیسز اسٹاک میں ہیں',
  continueAnyway: 'پھر بھی جاری رکھیں؟',
  lowStockLimit: 'کم اسٹاک حد',
  qtyType: 'مقدار کی قسم',
  qtyTypePack: 'پیک',
  qtyTypePiece: 'پیسز',
  packs: 'پیک',
  pack: 'پیک',
  piece: 'پیس',
  pieces: 'پیسز',
  pcSingular: 'پیس',
  pcPlural: 'پیسز',
  retailValue: 'ریٹیل قیمت',
  expectedProfit: 'متوقع منافع',
  activeOrg: 'فعال تنظیم',
  logoutConfirm: 'اس تنظیم سے لاگ آؤٹ کریں؟',
  invoiceCreatedMsg: 'انویس بن گیا! پرنٹ کے لیے تیار۔',
  invoiceErrorMsg: 'انویس بنانے میں خرابی: {error}',
  selectOrgBackupsHint: 'بیک اپ کے انتظام کے لیے "تمام تنظیمیں" ٹیب سے تنظیم منتخب کریں۔',
  noBackupsYet: 'ابھی تک کوئی بیک اپ نہیں۔ پہلا بیک اپ بنانے کے لیے "دستی بیک اپ" پر کلک کریں۔',
  runManualBackup: 'دستی بیک اپ چلائیں',
  backingUp: 'بیک اپ بن رہا ہے...',
  backupCompleted: 'بیک اپ کامیابی سے مکمل ہو گیا!',
  backupFailed: 'بیک اپ ناکام ہو گیا۔',
  autoBackupCompleted: 'تمام تنظیموں کا آٹو بیک اپ مکمل ہو گیا۔',
  dataBackup: 'ڈیٹا بیک اپ',
  lastBackup: 'آخری بیک اپ',
  noBackupYet: 'ابھی تک بیک اپ نہیں لیا گیا',
  backupDescription: 'آپ کا ڈیٹا خودکار طور پر روزانہ بیک اپ ہوتا ہے۔ ایڈمن کسی بھی وقت دستی بیک اپ بنا سکتے ہیں۔',
  size: 'سائز',
  restore: 'ری سٹور',
  restoreConfirm: 'کیا آپ واقعی اس بیک اپ کو ری سٹور کرنا چاہتے ہیں؟ اس سے اس تنظیم کا تمام موجودہ ڈیٹا اوور رائٹ ہو جائے گا۔',
  restoreCompleted: 'ڈیٹا بیس کامیابی سے ری سٹور ہو گیا!',
  restoreFailed: 'ری سٹور ناکام ہو گیا۔',
  recycleBin: 'ری سائیکل بن',
  recycleBinEmpty: 'ری سائیکل بن خالی ہے۔ حذف شدہ اشیاء یہاں دکھائی دیں گی۔',
  itemRestored: 'شے کامیابی سے بحال ہو گئی۔',
  permanentDeleteConfirm: 'یہ شے مستقل طور پر حذف کر دے گا۔ یہ عمل واپس نہیں کیا جا سکتا۔',
  itemPermanentlyDeleted: 'شے مستقل طور پر حذف ہو گئی۔',
  deleteFailed: 'حذف ناکام ہو گیا۔',
  price: 'قیمت',
  subtotalLabel: 'ذیلی کل',
  itemLabel: 'شے',
  grandTotal: 'کل رقم',
  paidAmount: 'ادا کردہ رقم',
  remainingBalance: 'باقی رقم',
  billTo: 'بل:',
  dateOfIssueLabel: 'تاریخ جاری:',
  chooseItem: 'شے منتخب کریں...',
  supplierLabel: 'سپلائر',
  itemsLabel: 'اشیاء',
  discount: 'رعایت',
  discountMode: 'رعایت کا طریقہ',
  discountModeDesc: 'انوائس میں رعایت کیسے درج کی جاتی ہے۔',
  discountWholeInvoice: 'پوری انوائس',
  discountWholeInvoiceDesc: 'پہلے کی طرح صرف ایک رعایت کا خانہ۔',
  discountPerItem: 'ہر آئٹم',
  discountPerItemDesc: 'ہر سطر میں رعایت کا خانہ؛ انوائس کی رعایت ان سب کا مجموعہ ہوتی ہے۔',
  discountBoth: 'دونوں (پوری + ہر آئٹم)',
  discountBothDesc: 'ہر سطر میں رعایت کا خانہ اور پوری انوائس کے لیے ایک خانہ؛ انوائس کی رعایت دونوں کا مجموعہ ہوتی ہے۔',
  discountItemsLabel: 'آئٹم کی رعایت',
  discountInvoiceLabel: 'انوائس کی رعایت',
  discountType: 'رعایت کی قسم',
  discountTypeDesc: 'رعایت کے خانے میں لکھی گئی عدد کو کیسے پڑھا جاتا ہے۔',
  discountTypeAmount: 'رقم (روپے)',
  discountTypeAmountDesc: 'سیدھی رقم۔ 200 لکھنے پر ہمیشہ 200 روپے کٹتے ہیں۔',
  discountTypePercent: 'فی صد (%)',
  discountTypePercentDesc: 'فی صد۔ 10 لکھنے پر اسی لائن کا 10% (آئٹم کے خانے) یا ذیلی کل کا 10% (انوائس کا خانہ) کٹتا ہے۔',
  cashInFlow: 'کیش آمد (+)',
  cashOutFlow: 'کیش نکاسی (-)',
  allCategories: 'تمام زمرے',
  logCashEntryBtn: 'کیش اندراج کریں',

  // Form Labels
  companyName: 'کمپنی/دکان کا نام',
  shopAddressLabel: 'دکان کا پتہ',
  officialEmail: 'سرکاری ای میل',
  contactPhone: 'رابطہ فون',
  contactName: 'رابطہ نام',
  staffName: 'عملے کا نام',
  baseSalaryLabel: 'بنیادی تنخواہ (Rs.)',
  chooseEmployee: '-- ملازم منتخب کریں --',
  periodStart: 'مدت شروع',
  periodEnd: 'مدت اختتام',
  allowancesLabel: 'الوانسز (Rs.)',
  deductionsLabel: 'کٹوتیاں (Rs.)',
  itemsSuppliedLabel: 'فراہم کردہ اشیاء',
  flowDirection: 'فلو کی سمت',
  fullName: 'پورا نام *',
  purchasePriceLabel: 'خریداری قیمت (Rs.)',
  salePriceLabel: 'فروخت قیمت (Rs.)',
  amountRs: 'رقم (Rs.)',

  // Placeholders
  phonePlaceholder: 'مثلاً 03001234567',
  pinPlaceholder: '****',
  adminPlaceholder: 'ایڈمن',
  shopNamePH: 'الرحمٰن جنرل سٹور',
  ownerNamePH: 'محمد علی',
  emailPH: 'malik@shop.com',
  addressPH: 'بلاک 4، سیکٹر G-11، اسلام آباد',
  pinSetupPH: 'مثلاً 7890',
  cnicPH: 'مثلاً 61101-1234567-1',
  itemsPH: 'مثلاً آٹا، انڈے، چینی کے بیگ',
  descPH: 'مثلاً گروسری آرڈر',
  rentPH: 'مثلاً دکان کا کرایہ',
  catPH: 'زمرے کا نام...',
  prodNamePH: 'مثلاً پریمی엄 ملک کیک',
  skuPH: 'مثلاً MC-001',
  unitPH: 'مثلاً پیس، کلو، ڈبہ',
  cnicFullPH: '35202-XXXXXXX-X',
  searchDesc: 'تفصیل سے تلاش کریں...',
  staffSearchPH: 'عملہ یا تنخواہ تلاش کریں...',
  salarySearchPH: 'ملازم کے نام سے تلاش کریں...',
  enterCurrentPIN: 'موجودہ پن درج کریں',
  enterNewPIN: 'نیا 4 ہندسوں کا پن درج کریں',
  confirmNewPINPH: 'نیا پن کی تصدیق',
  pricePH: '0.00',

  // Notifications
  loginFailed: 'لاگ ان ناکام۔ اپنی اسناد چیک کریں۔',
  sessionExpired: 'سیشن ختم ہو گیا۔ براہ کرم دوبارہ PIN درج کریں۔',
  downloadFailed: 'ڈاؤن لوڈ ناکام۔ دوبارہ کوشش کریں۔',
  popupBlocked: 'پاپ اپ بلاک ہو گیا۔ براہ کرم اس سائٹ کے لیے پاپ اپس اجازت دیں اور دوبارہ کوشش کریں۔',
  networkError: 'سرور تک رسائی نہیں ہو رہی۔ نیٹ ورک یا بیک اینڈ چیک کریں۔',
  regFailed: 'رجسٹریشن ناکام۔',
  regNetworkError: 'سرور تک رسائی نہیں ہو رہی۔ یقینی بنائیں کہ بیک اینڈ چل رہا ہے۔',
  invalidCredentials: 'غلط اسناد۔',
  pinMismatch: 'نیا پن اور تصدیق پن مماثل نہیں ہیں',
  pinLength: 'پن بالکل 4 ہندسوں کا ہونا چاہیے',
  pinChanged: 'پن کامیابی سے تبدیل ہو گیا!',
  pinFailed: 'پن تبدیل کرنے میں ناکامی',
  renewalSent: 'تجدید درخواست بھیج دی گئی! ایڈمن کی منظوری کا انتظار ہے۔',
  renewalFailed: 'تجدید درخواست بھیجنے میں ناکامی۔',
  partyAdded: '{type} کامیابی سے شامل ہو گیا!',
  udhaarLogged: 'عدھار لین دین لاگ ہو گیا!',
  cashSaved: 'کیش لین دین محفوظ ہو گیا!',
  ieLogged: 'آمدنی/اخراجات ریکارڈ لاگ ہو گیا!',
  productAdded: 'مصنوعات کیٹلاگ میں شامل ہو گئیں!',
  staffAdded: 'عملے کا رکن شامل ہو گیا!',
  salaryLogged: 'تنخواہ ادائیگی لاگ ہو گئی!',
  profileUpdated: 'کمپنی پروفائل اپڈیٹ ہو گیا!',
  partyUpdated: 'پارٹی اپڈیٹ ہو گئی!',
  cashUpdated: 'کیش اندراج اپڈیٹ ہو گیا!',
  productUpdated: 'مصنوعات اپڈیٹ ہو گئیں!',
  entryUpdated: 'اندراج اپڈیٹ ہو گیا اور بیلنس دوبارہحسب کیا گیا!',
  recordUpdated: 'ریکارڈ اپڈیٹ ہو گیا!',
  staffUpdated: 'عملے کی معلومات اپڈیٹ ہو گئیں!',
  deleted: '{name} حذف ہو گیا۔',
  cashDeleted: 'کیش اندراج حذف ہو گیا۔',
  productRemoved: '{name} ہٹا دیا گیا۔',
  recordDeleted: 'ریکارڈ حذف ہو گیا۔',
  staffRemoved: 'عملے کا رکن ہٹا دیا گیا۔',
  transactionDeleted: 'لین دین حذف ہو گیا اور بیلنس واپس ہو گیا۔',
  selectCustomerFirst: 'بل کے لیے براہ کرم صارف منتخب کریں۔',
  addItemAtLeast: 'براہ کرم کم از کم ایک شے قیمت کے ساتھ شامل کریں۔',
  invoiceFailed: 'انویس بنانے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔',
  invoiceCreated: 'انویس بن گیا! پرنٹ کے لیے تیار ہے۔',
  incorrectPin: 'غلط پن۔ براہ کرم دوبارہ کوشش کریں۔',
  salaryPaidTo: '{name} کو تنخواہ ادا کی گئی',

  // Delete confirmations
  deleteCustomer: 'صارف "{name}" حذف کریں؟',
  deleteSupplier: 'سپلائر "{name}" حذف کریں؟',
  deleteTransaction: 'یہ Rs.{amount} کا لین دین حذف کریں؟',
  removeProduct: '"{name}" کیٹلاگ سے ہٹائیں؟',
  removeStaff: '"{name}" عملے سے ہٹائیں؟',
  deleteRecord: 'یہ {type} ریکارڈ حذف کریں؟',
  deleteCashEntry: 'یہ کیش اندراج حذف کریں؟',

  // Print Reports
  cashBook: 'کیش بک',
  incomeExpense: 'آمدنی اور اخراجات',
  ledgerStatement: 'لیجر سٹیٹمنٹ',
  customerDirectory: 'صارفین کی ڈائری',
  supplierDirectory: 'سپلائرز کی ڈائری',
  stockInventory: 'اسٹاک انوینٹری',
  staffSalaryReport: 'عملہ اور تنخواہ رپورٹ',
  invoiceSummaryReport: 'انویس خلاصہ',
  businessOverview: 'کاروباری جائزہ',
  paymentReceipt: 'ادائیگی رسید',
  salarySlip: 'تنخواہ سلپ',
  reportDate: 'رپورٹ کی تاریخ',
  period: 'مدت',
  statementDate: 'سٹیٹمنٹ کی تاریخ',
  totalCashIn: 'کل کیش آمد',
  totalCashOut: 'کل کیش نکاسی',
  netBalance: 'خالص بیلنس',
  totalIncome: 'کل آمدنی',
  totalExpenses: 'کل اخراجات',
  netProfit: 'خالص منافع',
  netLoss: 'خالص نقصان',
  closingBalance: 'اختتامی بیلنس',
  surplus: '(فاضل)',
  deficit: '(کسر)',
  receivable: '(وصولی)',
  payable: '(ادائیگی)',
  totals: 'کل',
  closingBal: 'اختتامی بیلنس',
  totalOutstanding: 'کل باقی رقم',
  totalInventoryValue: 'کل انوینٹری قیمت',
  totalMonthlyPayroll: 'کل ماہانہ تنخواہ',
  totalInvoiceRevenue: 'کل انویس آمدنی',
  partyDetails: 'پارٹی کی تفصیلات',
  balanceSummary: 'بیلنس کا خلاصہ',
  receivableToGet: 'وصولی (ملے گا)',
  payableToGive: 'ادائیگی (دینا ہے)',
  employeeDetails: 'ملازم کی تفصیلات',
  netSalaryPaid: 'خالص تنخواہ ادا شدہ',
  employeeSignature: 'ملازم دستخط',
  authorizedSignatory: 'مجاز دستخط',
  companyNameLabel: 'کمپنی کا نام',
  myBusiness: 'میرا کاروبار',
  billTo: 'بل:',
  grandTotal: 'کل رقم:',
  dateOfIssueLabel: 'تاریخ جاری:',
  chooseItem: 'شے منتخب کریں...',
  supplierLabel: 'سپلائر',
  itemsLabel: 'اشیاء',
  yourCompany: 'آپ کی کمپنی کا نام',
  companyAddress: 'کمپنی کا پتہ',
  from: 'سے',
  to: 'کو',
  entry: 'اندراج',
  gaveUdhaar: 'عدھار دیا',
  gotPayment: 'ادائیگی ملی',
  signatureLine: '___________________________',

  // Tab filter buttons
  filterAll: 'تمام وقت',
  filterDaily: 'روزانہ',
  filterWeekly: 'ہفتہ وار',
  filterMonthly: 'ماہانہ',
  filterYearly: 'سالانہ',
  filterCustom: 'حسب ضرورت',  fromDate: 'تاریخ سے',
  toDate: 'تاریخ تک',
  fromTime: 'وقت سے',
  toTime: 'وقت تک',
  clearFilters: 'صاف کریں',
  deleteLogConfirm: 'کیا آپ یہ لاگ اندراج حذف کرنا چاہتے ہیں؟',
  // Empty states
  noLogsFound: 'کوئی لاگ نہیں ملا۔',
  noResults: 'کوئی نتائج نہیں ملے۔',

  // Misc
  syncStatus: 'مطابقت پذیر',
  unsaved: 'غیر محفوظ',
  rs: 'Rs.',
  selectDate: 'تاریخ منتخب کریں',
  darkMode: 'ڈارک موڈ',
  lightMode: 'لائٹ موڈ',
  whatsappMsg: 'محترم {name}، {biz} میں آپ کی وقف رقم Rs. {amount} ہے۔ براہ کرم جلد ادا کریں۔',

  // Dashboard card subtitles & labels
  allTimeComparison: 'تمام وقت کا موازنہ',
  cashRecPayables: 'کیش، وصولیاں اور ادائیگیاں',
  cashBalanceLabel: 'کیش بیلنس',
  receivablesLabel: 'وصولیاں',
  payablesLabel: 'ادائیگیاں',
  activeShop: 'فعال دکان',
  settled: 'تسلیم شدہ',
  runningBalance: 'بیلنس',
  get: 'ملے گا',
  give: 'دینا ہے',
  low: '(کم)',
  staffProductsInvoices: '{staffCount} عملہ · {productCount} مصنوعات · {invoiceCount} انویس',

  // Dashboard card labels
  customersLabel: 'صارفین',
  suppliersLabel: 'سپلائرز',
  productsLabel: 'مصنوعات',
  employeesLabel: 'ملازمین',
  customerOutstanding: 'صارفین کی باقی رقم',
  supplierOutstanding: 'سپلائرز کی باقی رقم',
  stockValue: 'اسٹاک قیمت',
  invoicesLabel: 'انویس',
  cashInLabel: 'کیش آمد',
  cashOutLabel: 'کیش نکاسی',
  totalCustomers: 'کل صارفین',
  totalSuppliers: 'کل سپلائرز',
  totalReceivable: 'کل وصولی',
  totalPayable: 'کل ادائیگی',
  netOutstanding: 'خالص باقی رقم',
  totalEmployees: 'کل ملازمین',
  totalPaid: 'کل ادا شدہ',
  dailyWage: 'روزانہ مزدوری',
  totalInvoices: 'کل انویس',
  paid: 'ادا شدہ',
  unpaid: 'غیر ادا',
  totalRevenue: 'کل آمدنی',
  productsCount: 'مصنوعات',
  totalUnits: 'کل اکائیاں',
  totalStockValue: 'کل اسٹاک قیمت',

  // Print Report headers
  balance: 'بیلنس',
  customerDetails: 'صارف کی تفصیلات',
  summary: 'خلاصہ',
  totalDue: 'کل واجب الادا',
  pendingOnLedger: 'لیجر پر زیر التوا',
  slipRef: 'سلپ حوالہ',
  dateIssued: 'تاریخ جاری',
  employmentType: 'ملازمت کی قسم',
  payPeriod: 'تنخواہ کی مدت',
  basicSalary: 'بنیادی تنخواہ',
  printReceipt: 'رسید پرنٹ کریں',
  backToLedger: 'لیجر پر واپس',
  backToBillBook: 'بل بک پر واپس',
  printInvoice: 'انویس پرنٹ کریں',
  backToStaff: 'عملہ پر واپس',
  printSalarySlip: 'تنخواہ سلپ پرنٹ کریں',

  // Title attributes
  editCompanyInfo: 'کمپنی کی معلومات میں ترمیم',
  toggleTheme: 'تھیم تبدیل کریں',
  lockSession: 'سیشن لاک کریں',
  toggleLanguage: 'زبان تبدیل کریں',
  printIEReport: 'آمدنی/اخراجات رپورٹ پرنٹ کریں',
  printStockReport: 'اسٹاک رپورٹ پرنٹ کریں',
  printStaffReport: 'عملہ اور تنخواہ رپورٹ پرنٹ کریں',
  printInvoiceReport: 'انویس رپورٹ پرنٹ کریں',
  generateSalarySlip: 'تنخواہ سلپ بنائیں',
  sendSalarySlipWA: 'تنخواہ سلپ واٹس ایپ پر بھیجیں',
  sendInvoiceWA: 'انویس واٹس ایپ پر بھیجیں',
  sendWhatsApp: 'واٹس ایپ پیغام بھیجیں',

  // Staff directory
  ofEmployees: 'میں سے',

  // Login placeholders
  phoneExamplePH: 'مثلاً 03001234567',
  addressExamplePH: 'بلاک 4، سیکٹر G-11، اسلام آباد',
  adminExamplePH: 'ایڈمن',
  pinExamplePH: 'مثلاً 7890',

  // WhatsApp Templates
  waTemplatesTitle: 'واٹس ایپ پیغام ٹیمپلیٹس',
  waTemplatesDesc: 'صارفین، سپلائرز اور ملازمین کو واٹس ایپ پر بھیجنے والے پیغامات کو ترتیب دیں۔',
  waBalanceReminder: 'بیلنس یاد دہانی',
  waBalanceReminderDesc: 'باقی رقم یاد کرنے کے لیے صارفین/سپلائرز کو بھیجا جاتا ہے',
  waTransactionReceipt: 'لین دین رسید',
  waTransactionReceiptDesc: 'ہر لیجر اندراج کے بعد رسید کے طور پر بھیجا جاتا ہے',
  waInvoiceMessage: 'انویس پیغام',
  waInvoiceMessageDesc: 'انویس اور بیلنس تفصیلات کے ساتھ صارفین کو بھیجا جاتا ہے',
  waSalarySlip: 'تنخواہ سلپ',
  waSalarySlipDesc: 'تنخواہ کی تفصیلات کے ساتھ ملازمین کو بھیجا جاتا ہے',
  waAvailableVars: 'دستیاب متغیرات ( داخل کرنے کے لیے کلک کریں)',
  waPreview: 'براہ راست پیش نظارہ',
  waResetDefault: 'ڈیفالٹ پر ری سیٹ کریں',
  waShareModeTitle: 'واٹس ایپ شیئر کا طریقہ',
  waShareModeDesc: 'آپ جب بھی ایپ میں واٹس ایپ کے کسی بٹن پر کلک کریں تو کیا بھیجا جائے۔',
  waShareModeText: 'متنی پیغام',
  waShareModeTextDesc: 'نیچے دیا گیا ترتیب شدہ متنی ٹیمپلیٹ بھیجیں۔',
  waShareModeImage: 'تصویری کارڈ',
  waShareModeImageDesc: 'آپ کے اپنے ڈیٹا سے بنا برانڈڈ تصویری کارڈ بھیجیں۔',
  waShareModePreview: 'تصویری کارڈ کا پیش نظارہ',
  waYouGave: 'آپ نے دیا',
  waYouGot: 'آپ کو ملا',
  waRunningBalance: 'چلتا بیلنس',
  waCardDownloaded: 'کارڈ کی تصویر ڈاؤن لوڈ ہو گئی! کھلے ہوئے واٹس ایپ چیٹ میں منسلک کریں۔',
  waCardCopied: 'کارڈ کی تصویر کاپی ہو گئی! واٹس ایپ چیٹ میں Ctrl+V سے پیسٹ کر دیں۔',
  waCardFallback: 'تصویر نہیں بن سکی، اس لیے متنی پیغام بھیج دیا گیا۔',

  // Stock Tab Toggle & History
  stockTab: 'اسٹاک',
  stockHistoryTab: 'اسٹاک ہسٹری',
  stockHistory: 'اسٹاک ہسٹری اور سپلائر لاگ',
  stockHistoryDesc: 'اسٹاک کہاں سے آیا اس کا ریکارڈ، بشمول سپلائر کے نام اور خریداری انویس۔',
  noStockMovements: 'ابھی تک کوئی اسٹاک تحریک ریکارڈ نہیں ہوئی۔',
  stockIn: 'اسٹاک آمد',
  stockOut: 'اسٹاک نکاسی',
  adjustment: 'ایڈجسٹمنٹ',
  supplierOrDesc: 'سپلائر / تفصیل',
  product: 'مصنوع',
  typeNewProduct: 'نئی مصنوع کے طور پر شامل کرنے کے لیے اوپر ٹائپ کریں',
  unknownProduct: 'نامعلوم مصنوع',
  salePrice: 'ریٹیل قیمت',
  purchasePrice: 'خریداری قیمت',
  unit: 'اکائی مقدار',
  subtotal: 'ذیلی کل',
  addNewProductLabel: '"{name}" کو نئی مصنوع کے طور پر شامل کریں',

  // Business Card Designer
  businessCardDesigner: 'بزنس کارڈ ڈیزائنر',
  selectTemplate: 'ٹیمپلیٹ منتخب کریں',
  minimalist: 'سادہ اور خوبصورت',
  modernDark: 'جدید (سیاہ)',
  creativeGradient: 'رنگین اور تخلیقی',
  organicGreen: 'قدرتی سبز',
  navyGoldLuxury: 'نیوی گولڈ لگژری',
  mandala: 'منڈلا (روایتی)',
  cardDetails: 'کارڈ کی تفصیلات',
  companyName: 'کمپنی کا نام',
  companyTagline: 'کمپنی کی خصوصیات / ٹیگ لائن',
  personName: 'آپ کا نام',
  tagline: 'عہدہ / کردار',
  primaryColor: 'بنیادی رنگ',
  printSingle: 'ایک کارڈ پرنٹ کریں',
  printGrid: 'گرڈ پرنٹ کریں (10 کارڈز)',
  brandLogo: 'برانڈ کا لوگو',

  // Bulk / Big Unit & Packaging
  bigUnitBulk: 'پیکنگ / بڑی اکائی (اختیاری)',
  bulkUnitName: 'پیکنگ اکائی (کارٹن/باکس)',
  unitsPerBulk: 'فی پیکنگ تعداد (دانے)',
  bulkPurchasePrice: 'پیکنگ خریداری لاگت',
  bulkSalePrice: 'پیکنگ فروخت قیمت',
  pieceCost: 'فی دانہ لاگت',
  piecePrice: 'فی دانہ قیمت',
  packageCost: 'پیکنگ لاگت',
  packagePrice: 'پیکنگ قیمت',
  packagesCount: 'پیکنگ / کارٹن تعداد',
  loosePieces: 'کھلے دانے',
  totalPieces: 'کل دانے / تعداد',
  packagingHelper: '1 {bulk} = {count} دانے',

  // Print Customization
  printCustomizationTitle: 'انوائس اور رپورٹس پرنٹ کی ترتیبات',
  printCustomizationDesc: 'پرنٹ شدہ انوائسز پر فیلڈز چھپانے یا دکھانے، ہیڈر اور لوگو کی پوزیشن تبدیل کرنے، انوائس کے اختتامی پیغامات اور رپورٹس کے نوٹس سیٹ کریں۔',
  invoicesPrintTab: 'انوائس پرنٹ ترتیبات',
  reportsPrintTab: 'رپورٹس پرنٹ نوٹس',

  // Layout & Branding
  headerAndLayout: 'ہیڈر اور لے آؤٹ',
  logoPosition: 'لوگو کی پوزیشن',
  logoLeft: 'بائیں جانب',
  logoCenter: 'درمیان میں',
  logoRight: 'دائیں جانب',
  logoNone: 'چھپائیں',
  headerLayout: 'ہیڈر کا انداز',
  headerStandard: 'معیاری (الگ الگ)',
  headerCentered: 'مرکزی (درمیان میں)',
  itemsPosition: 'حصوں کی ترتیب',
  itemsStandard: 'کسٹمر تفصیلات پہلے',
  itemsFirst: 'آئٹمز ٹیبل پہلے',

  // Field visibility
  fieldVisibility: 'فیلڈز اور کالمز ظاہر یا پوشیدہ کریں',
  showSerialNumber: 'سیریل نمبر (S.N) کالم',
  showSerialNumberDesc: 'انوائس آئٹمز ٹیبل میں نمبر شمار کا کالم دکھائیں یا چھپائیں',
  showSubtotal: 'سب ٹوٹل رقم',
  showSubtotalDesc: 'ڈسکاؤنٹ سے پہلے کی کل رقم دکھائیں',
  showDiscount: 'ڈسکاؤنٹ کی لائن',
  showDiscountDesc: 'انوائس میں دیا گیا ڈسکاؤنٹ دکھائیں',
  showPaidAmount: 'ادا شدہ رقم',
  showPaidAmountDesc: 'صارف کی طرف سے ادا کردہ رقم دکھائیں',
  showRemainingBalance: 'بقایا بیلنس',
  showRemainingBalanceDesc: 'اس انوائس پر باقی رہ جانے والا بیلنس دکھائیں',
  showPartyPhone: 'صارف / سپلائر کا فون نمبر',
  showPartyPhoneDesc: 'پرنٹ شدہ رسید پر رابطہ نمبر دکھائیں',
  showPartyCnic: 'صارف / سپلائر کا شناختی کارڈ',
  showPartyCnicDesc: 'شناختی کارڈ نمبر دکھائیں اگر درج ہو',
  showPartyAddress: 'صارف / سپلائر کا پتہ',
  showPartyAddressDesc: 'پرنٹ شدہ رسید پر مکمل پتہ دکھائیں',
  showBusinessAddress: 'ہیڈر میں کاروباری پتہ',
  showBusinessAddressDesc: 'اوپر ہیڈر میں اپنی دکان یا کمپنی کا پتہ دکھائیں',
  showBusinessPhoneEmail: 'ہیڈر میں فون اور ای میل',
  showBusinessPhoneEmailDesc: 'ہیڈر میں رابطہ نمبر اور ای میل دکھائیں',
  showInvoiceTime: 'انوائس تاریخ کے ساتھ وقت',
  showInvoiceTimeDesc: 'تاریخ کے ساتھ جاری کرنے کا وقت بھی دکھائیں',
  showSignatureBlock: 'دستخط کی جگہ',
  showSignatureBlockDesc: 'نیچے کسٹمر اور مجاز افسر کے دستخط کی لائنز دکھائیں',
  customerSignature: 'دستخط گاہک',
  authorizedSignature: 'دستخط مجاز افسر',

  // Footer note / End message
  invoiceFooterNote: 'انوائس کے آخر میں نوٹ یا پیغام',
  enableInvoiceNote: 'انوائس کے آخر میں نوٹ / پیغام دکھائیں',
  noteTitleLabel: 'نوٹ کا عنوان / لیبل',
  noteTitlePlaceholder: 'مثلاً: نوٹ:، شرائط و ضوابط:، شکریہ:',
  noteTextLabel: 'پیغام کا متن',
  noteTextPlaceholder: 'اپنی شرائط، واپسی کی پالیسی یا شکریہ کا پیغام لکھیں...',
  quickPresets: 'تیار پیغامات',
  presetThankYou: 'آپ کے تعاون کا بہت شکریہ!',
  presetNoReturn: 'بکا ہوا مال واپس یا تبدیل نہیں ہوگا۔',
  presetTerms: 'ادائیگی 15 دن میں لازمی ہے۔ وارنٹی انوائس کے ساتھ قابل قبول ہے۔',

  // Reports print notes
  reportsNotesTitle: 'رپورٹس پرنٹ نوٹس و پیغامات',
  reportsNotesDesc: 'پرنٹ ہونے والی رپورٹس کے نیچے حسب ضرورت نوٹ یا ہدایات شامل کریں۔ آپ تمام رپورٹس کے لیے یا مخصوص ٹیب کے لیے الگ نوٹ رکھ سکتے ہیں۔',
  enableReportNote: 'پرنٹ شدہ رپورٹس پر نوٹ دکھائیں',
  globalReportNote: 'عمومی رپورٹ نوٹ (تمام رپورٹس پر لاگو ہوگا)',
  globalReportNotePlaceholder: 'مثلاً: یہ دستاویز اندرونی اکاؤنٹنگ کے لیے ہے۔',
  tabSpecificNotes: 'مخصوص ٹیبز کے نوٹس (عمومی نوٹ کی جگہ آئے گا)',
  selectTabToCustomize: 'سیکشن کا انتخاب کریں',
  tabNoteTitlePlaceholder: 'مثلاً: ہدایات، شرائط، نوٹ',
  tabNoteTextPlaceholder: 'اس مخصوص رپورٹ کے لیے پیغام...',
  resetPrintSettings: 'اصل حالت پر بحال کریں',
  previewInvoice: 'انوائس کا پیش نظارہ',
  closePreview: 'پیش نظارہ بند کریں',
  previewNotice: 'یہ آپ کی موجودہ ترتیبات کے مطابق نمونہ پیش نظارہ ہے۔',

  // Custom Table Column Headers
  customColumnHeaders: 'کالمز کے عنوانات تبدیل کریں',
  customColumnHeadersDesc: 'پرنٹ شدہ انوائس پر کالمز کے عنوانات اپنی مرضی کے مطابق رکھیں۔ خالی چھوڑنے پر بنیادی نام استعمال ہوں گے۔',
  colSerialNo: 'نمبر شمار (S.N)',
  colItemDescription: 'پروڈکٹ / آئٹم کا نام',
  colQuantity: 'تعداد (مقدار)',
  colUnitPrice: 'قیمت / ریٹ',
  colSubtotal: 'کل رقم',
  packagingHeadersOptional: 'پیکنگ / کارٹن کے عنوانات (اختیاری)',
  colBulkQuantity: 'پیکنگ اکائی (مثلاً کارٹن)',
  colSmallQuantity: 'کھلے دانے (PC)',
  colBulkPrice: 'پیکنگ قیمت / لاگت',
  colSmallPrice: 'فی دانہ قیمت / لاگت',
  resetColumnNames: 'کالمز کے نام اصل حالت پر بحال کریں',

  // ── Key-sync repairs ─────────────────────────────────────────────────────
  // Urdu counterparts of the keys repaired in en.js (the UI rendered raw
  // keys for these), plus the two keys that previously existed only in
  // English and fell back at runtime.
  addBoth: 'کسٹمر/سپلائر شامل کریں',
  addItem: 'آئٹم شامل کریں',
  allBankAccounts: 'تمام بینک اکاؤنٹس',
  allTransactionTypes: 'تمام قسم کے لین دین',
  bankOnline: 'بینک / آن لائن',
  bankTransaction: 'بینک لین دین',
  both: 'دونوں',
  cashEntry: 'نقد اندراج',
  companyLogo: 'کمپنی کا لوگو',
  deleteDuplicateEntry: 'کیا یہ دہراوا اندراج حذف کریں؟',
  deleteMovement: '{date} کی حرکت حذف کریں؟',
  deposits: 'جمع',
  duplicateEntryFound: 'دہراوا اندراج ملا',
  duplicateEntryMessage: 'یہ ریکارڈ بالکل ایک جیسے ہیں۔ پہلا ریکارڈ برقرار رہے گا۔',
  editStockMovement: 'اسٹاک حرکت میں ترمیم',
  enterBankName: 'بینک کا نام درج کریں',
  entries: 'اندراجات',
  error: 'خرابی',
  general: 'عمومی',
  fromDate: 'تاریخ شروع',
  incomeByCat: 'آمدن / اخراجات زمرہ وار',
  invoices: 'رسیدیں اور ڈے بک',
  keep: 'رکھیں',
  loss: 'نقصان',
  note: 'نوٹ',
  other: 'دیگر',
  overview: 'کاروبار کا جائزہ',
  party: 'پارٹی',
  printBusinessOverview: 'کاروباری جائزہ پرنٹ کریں',
  printCustomerDirectory: 'کسٹمر ڈائریکٹری پرنٹ کریں',
  printSupplierDirectory: 'سپلائر ڈائریکٹری پرنٹ کریں',
  profit: 'منافع',
  purchaseHistory: 'خریداری کی تاریخ',
  remove: 'ہٹائیں',
  set: 'مقرر',
  stockMovement: 'اسٹاک حرکت',
  totalEntries: 'کل اندراجات',
  transaction: 'لیجر لین دین',
  website: 'ویب سائٹ',
  withdrawals: 'نکاسی'
};

export default ur;
